import React from 'react'
import PropTypes from 'prop-types'
import GoogleMapReact from 'google-map-react'
import MapPin from 'components/MapPin'
import { happeningNow, minutes } from 'utils/timer'
import { STAGE_TASK_COUNTER, STAGE_BREAK_COUNTER } from 'constants'

export const MapComponent = ({ usersTodayArray, classes }) => (
  <GoogleMapReact
    defaultCenter={{ lat: 40, lng: 260 }}
    defaultZoom={1}
    bootstrapURLKeys={{
      key: 'AIzaSyCPs_qC6ns9z1SXRASSR_phlJwpE0AeVt4',
      language: 'en',
    }}>
    {usersTodayArray.map(
      ({ uid, lat, lng, dumoDesc, breakDesc, stage, lastSeen }, idx) =>
        stage === STAGE_TASK_COUNTER &&
        happeningNow(lastSeen, minutes(25)) &&
        lat &&
        lng ? (
          <MapPin
            key={idx}
            onBreak={false}
            text={dumoDesc}
            lng={lng}
            lat={lat}
          />
        ) : stage === STAGE_BREAK_COUNTER &&
        happeningNow(lastSeen, minutes(5)) &&
        lat &&
        lng ? (
          <MapPin key={idx} text={breakDesc} lng={lng} lat={lat} />
        ) : null
    )}
  </GoogleMapReact>
)

MapComponent.propTypes = {
  classes: PropTypes.object,
  usersTodayArray: PropTypes.array.isRequired,
}

export default MapComponent



// WEBPACK FOOTER //
// ./src/components/Map/Map.js